import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Accordion as MuiExpansionPanel,
  AccordionSummary as MuiExpansionPanelSummary,
  AccordionDetails as MuiExpansionPanelDetails,
  Typography,
  FormControl,
  NativeSelect,
  CircularProgress,
  Button,
  Card,
  Grid,
  Box
} from "@material-ui/core";
import {
  ExpandMore as ExpandMoreIcon,
  Edit as EditIcon,
  CallEnd as CallEndIcon,
} from "@material-ui/icons";
import CallIcon from '@mui/icons-material/Call';
import GroupIcon from '@mui/icons-material/Group';


//import DialpadIcon from '@material-ui/icons/Dialpad';
import Conference from "./components/Conference/Conference";
import DialpadIcon from "./components/Preview/PreviewDialIcon.js";
import TransferCallButton from "./components/Transfer/TransferCallButton";

//import CustomerDetails from "./components/CustomerLead/CustomerDetails";
import ShowCustomerDetails from "./components/CustomerLead/ShowCustomerDetails";
import EditCustomerDetails from "./components/CustomerLead/EditCustomerDetails";
import Progressive from "./components/Progressive/Progressive.png";
import PhoneTypes from "./components/CustomerLead/PhoneTypes";
import HoldButton from "./Hold";
import useStyles from "./styles";

//store
import * as actions from "../../store/actions/actionIndex";

import {decryptPhoneNumber, localStorageFunc, notify } from "../../helpers/utility";
import DtmfButton from "./components/DTMF/DtmfButton.js";
import Break from "../../components/Break/Break";
import { localeData } from "moment/moment.js";
import CallParking from "./components/CallPark/CallParking.js";
// import DtmfButton from "./DTMF/DtmfButton";
const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    height: "0.5",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    flexFlow: "row wrap",
    marginBottom: -1,
    minHeight: 40,
    "&$expanded": {
      minHeight: 40,
    },
  },
  content: {
    "&$expanded": {
      margin: "10px 0",
    },
  },
  expanded: {},
})(MuiExpansionPanelSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiExpansionPanelDetails);

function CustomizedExpansionPanels(props) {
  var classes = useStyles();
window.decryptFunction  = decryptPhoneNumber ;
  const {
    newFeatures,
    agentId,
    onGetCustomerDetails,
    campaignId,
    sessionId,
  } = props;

  var crmFields = Array.from(props.crmFields);
  const [expanded, setExpanded] = useState([]);

  
  const [editMode, seteditMode] = useState({});
  const [confRoom, setConfRoom] = useState(1);
  const [crmValues, setValues] = useState(props.crmValues);
  const [multiConf, setMultiConf] = useState(0);
  const [showCallPark, setShowCallPark] = useState(false)
  useEffect(() => {
    try {
      setMultiConf(newFeatures.multiconference === "1" ? 1 : 0);
    } catch (e) {}
  }, [newFeatures, setMultiConf]);

  let activeLeadId =
    props.agentState === "INCALL" ||
    props.agentState === "CLOSURE" ||
    props.agentState === "PREVIEW_FAIL"
      ? props.leadId
      : props.activeLeadId;
  const [confShow, setConfShow] = useState(
    props.agentState === "FREE" ||
      props.agentState === "INCALL" ||
      props.agentState === "CLOSURE" ||
      props.agentState === "PREVIEW_FAIL" ||
      props.agentState === "CONF" ||
      props.agentState === "BREAK"
      ? true
      : false
  );
  const [confFlag, setConfFlag] = useState(
    props.agentState === "CONF" || props.breakType === "JoinedConference"
     ? true : false
  );
  const [callFlag, setCallFlag] = useState(false)

  useEffect(() =>{
    if( props.agentState === "CONF" || props.breakType === "JoinedConference"){
      setConfFlag(true)
    }
    else{
      setConfFlag(false)
    }
  },[props.agentState, props.breakType])
  useEffect(() => {
    setConfShow(
      props.agentState === "FREE" ||
        props.agentState === "INCALL" ||
        props.agentState === "CLOSURE" ||
        props.agentState === "PREVIEW_FAIL" ||
        props.agentState === "CONF" ||
        props.agentState === "BREAK"
        ? true
        : false
    );
  }, [props.agentState, setConfShow]);

  useEffect(() => {
    if (parseInt(activeLeadId)) {
      onGetCustomerDetails(agentId, campaignId, activeLeadId);
    }
  }, [agentId, campaignId, activeLeadId, onGetCustomerDetails, sessionId]);

  useEffect(() => {
    setValues(props.crmValues);
    seteditMode({});
  }, [props.crmValues]);

  // useEffect(() => {
  //   setValues(props.basicValues);
  //   seteditMode({});
  // }, [props.basicValues]);
  
  const setPanelWiseEditMode = (panelId, val) => {
    seteditMode((state) => {
      return {
        ...state,
        [panelId]: val,
      };
    });
  };

  useEffect(() => {
    const { sessionId, leadId, agentState, crmValues } = props;
  
    // If agent is FREE, reset everything
    if (agentState === "FREE") {
      localStorageFunc.erase("crmValues");
      localStorageFunc.erase("matchWithDisp");
      localStorageFunc.set("crmUpdate", "false");
      localStorageFunc.erase("mandatoryFlag");
      return;
    }
  
    // Handle session ID change
    if (sessionId) {
      const storedSessionId = localStorageFunc.get("sessionId");
      if (storedSessionId && sessionId !== storedSessionId) {
        localStorageFunc.erase("crmValues");
        localStorageFunc.erase("matchWithDisp");
        localStorageFunc.set("crmUpdate", "false");
        props.onResetCustomerDetails();
        props.onRestDisconnect();
      }
      localStorageFunc.set("sessionId", sessionId);
    }
  
    // Handle lead ID change
    if (leadId) {
      const storedLeadId = localStorageFunc.get("initialLeadId");
      if (storedLeadId && leadId !== storedLeadId) {
        localStorageFunc.erase("crmValues");
        localStorageFunc.erase("matchWithDisp");
        localStorageFunc.set("crmUpdate", "false");
        props.onResetCustomerDetails();
      }
    }
  }, [props.sessionId, props.leadId, props.agentState]);
  
  // Separate effect for syncing crmValues when update flag is false
  useEffect(() => {
    const { agentState, crmValues } = props;
  
    if (agentState !== "FREE") {
      const flagUpdate = localStorageFunc.get("crmUpdate") || "false";
      if (flagUpdate === "false") {
        localStorageFunc.set("crmValues", JSON.stringify({}));
        setTimeout(() => {
          localStorageFunc.set("crmUpdate", "true");
        }, 3000);
      }
    }
  }, [props.crmValues, props.agentState]);
  
  const [abc, setAbc] = useState({});
  useEffect(() => {
    try {
      const storedData = localStorageFunc.get("crmValues");
      setAbc(storedData ? JSON.parse(storedData) : {});
    } catch (error) {
      setAbc({});
    }
  }, [crmValues]);

  
  // Toggle panel expansion (multi-open support)
 
  const handleCrmChange = (event) => {
    event.persist();
    const updatedValues = {
      ...crmValues,
      ...abc,
      [event.target.name]: event.target.value,
    };
   
    setValues(updatedValues);
  
    // Set the updated crmValues in localStorage
    localStorageFunc.set("crmValues", JSON.stringify(updatedValues));
  };

  
  
  
  useEffect(() => {
    const validateMandatoryFields = () => {
      let mandatoryFlag = "0";
      let missingFields = [];
      const storedCrmValues = JSON.parse(localStorageFunc.get("crmValues") || "{}");
      if (!storedCrmValues || Object.keys(storedCrmValues).length === 0) {
        return;
      }

//       const hasCrmFields = crmFields?.some(group => group.group?.length);
// const fieldSource = hasCrmFields ? crmFields : basicFields;
crmFields.forEach((fieldGroup) => {
        fieldGroup.group.forEach((field) => {
          const fieldValue = storedCrmValues[field.name];
          if (field.mandatory) {
            if (field.type === "select") {
              if (!fieldValue || fieldValue === "Select") {
                mandatoryFlag = "1";
                missingFields.push(field.label); 
              }
            } else if (field.type === "datetime-local") {
              if (!fieldValue || fieldValue === "0000-00-00 00:00:00") {
                mandatoryFlag = "1";
                missingFields.push(field.label);
              }
            } else {
              // For other field types, check if the value is empty
              if (!fieldValue) {
                mandatoryFlag = "1";
                missingFields.push(field.label);
              }
            }
          }
        });
      });
      
      localStorageFunc.set("mandatoryFlag", mandatoryFlag);
      if (mandatoryFlag === "1") {
        localStorageFunc.set("missingFields", JSON.stringify(missingFields));
      } else {
        localStorageFunc.erase("missingFields");
      }
    };
  
    validateMandatoryFields();
  }, [crmValues, abc, crmFields]);
  

  const handleUpdate = () => {
    const storedMandatoryFlag = localStorageFunc.get("mandatoryFlag");
    const missingFields = JSON.parse(localStorageFunc.get("missingFields") || "[]");
    const GetFieldsData = JSON.parse(localStorageFunc.get("crmValues"));

    try {
      if (!GetFieldsData) {
          notify("CRM Error: No data to update", "crm-error");
       } else {
         if (storedMandatoryFlag === "0" || storedMandatoryFlag === null) {
          props.onCustomerDetails(
            props.agentId,
            props.campaignId,
            props.leadId,
            crmValues
          );
          seteditMode({});
        } 
        else {
          notify(`CRM Error: Please fill the following mandatory fields: ${missingFields[0]}.`, "crm-error");
       
      }
    }
   } catch (error) {
      notify("CRM Error: An unexpected error occurred.", "crm-error");
    }
  };

const fieldSource = crmFields ;

const validPanels = fieldSource.filter((item) => item.group.length > 0);
 
  useEffect(() => {
    const defaultExpanded = validPanels
      .map((item, index) => (item.show_groups_crm_flag === "1" ? `panel${index}` : null))
      .filter(Boolean);
    setExpanded(defaultExpanded);
  }, [ props.crmFields]);
  
  const handleChange = (panelId) => (event, isExpanded) => {
    setExpanded((prevExpanded) =>
      isExpanded ? [...prevExpanded, panelId] : prevExpanded.filter((p) => p !== panelId)
    );
  };
  const leaveConf = () => {
    props.onLeaveConf(props.agentId);
    props.onGetConfDetails(props.agentId);
  };
  const joinConf = () => {
    props.onJoinConf(props.agentId, "join_agent_cust_conf", confRoom, "");
    props.onGetConfDetails(props.agentId);
  };
  const joinCustomer = () => {
    props.onJoinConf(props.agentId, "transfer", confRoom, props.custPhone);
    props.onGetConfDetails(props.agentId);
  };
  const joinAgent = () => {
    props.onJoinConf(props.agentId, "joinconf", confRoom, "");
    props.onGetConfDetails(props.agentId);
  };


  useEffect(() => {
    if (props.sessionId) {
      const storedSessionId = localStorageFunc.get("sessionId");
      if (storedSessionId && props.sessionId !== storedSessionId) {
        localStorageFunc.erase("crmValues");
        localStorageFunc.erase("matchWithDisp");
        localStorageFunc.set("crmUpdate", "false");
        props.onResetCustomerDetails();
      } else {
        console.log("Session IDs match or no previous session ID found!");
      }
      localStorageFunc.set("sessionId", props.sessionId);
    }
  }, [props.sessionId]);

  useEffect(() =>{
    if(props.agentState === "FREE"){
      localStorageFunc.erase("crmValues");
      localStorageFunc.erase("matchWithDisp");
      localStorageFunc.set("crmUpdate","false"); 
      localStorageFunc.erase("mandatoryFlag");
    }
   if (props.failedReason !== ""){
    notify(props.failedReason, "call-error")
   }

  },[props.agentState, props.failedReason])
const handleAgentDial = ({ dialNumber, phoneType, leadId, callerId }) => {
  props.onAgentDial(props.agentId, dialNumber, leadId, "", callerId, false, phoneType);
};

useEffect(() =>{
 if (props.callConfDetails?.length >= 2 && !confFlag ){
    setCallFlag(true)
  }
},[props.callConfDetails])

useEffect(() =>{
  if(props.agentState === "INCALL"){
  if (typeof window.bcScriptFunction === "function") {
      window.bcScriptFunction();
    }
  }
},[props.agentState])

// const handleCallPark =() =>{
//   console.log("neha")
//  setCallFlag(prev => !prev)
//  setConfFlag(false)
 
// }
const handleConfFlag = () =>{
 setConfFlag(!confFlag)
 setCallFlag(false)
 setShowCallPark(false)
}
const showParkCall = () =>{
  setShowCallPark(prev => !prev)
   setCallFlag(false)
 setConfFlag(false)
}
  const callHandlerMainDivRef = useRef(null);
  const callHandlerFixedDivRef = useRef(null);

   useEffect(() => {
    const syncChildPosition = () => {
      const parent = callHandlerMainDivRef.current;
      const child = callHandlerFixedDivRef.current;
      if (parent && child) {
        const rect = parent.getBoundingClientRect();
        child.style.insetInlineStart = `${rect.left}px`;
        child.style.width = `${rect.width}px`;
      }
    };

    // Run once on mount
    syncChildPosition();

    // Re-run on scroll and resize
    window.addEventListener('resize', syncChildPosition);
    window.addEventListener('scroll', syncChildPosition);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('resize', syncChildPosition);
      window.removeEventListener('scroll', syncChildPosition);
    };
  }, []);
  return (
   <div
      ref={callHandlerMainDivRef}
      style={{ marginTop: "0px" }}
      className={`${classes.LeadInformationGrid} callHandlerMainDiv`}
      xs={"false"}
      md={"false"}
      lg={"false"}
    >
      <div className="callHandlerWrapper">
      <Box
        ref={callHandlerFixedDivRef}
        className="callHandlerFixedDiv"
        sx={{
          position: {
            xs: "static",
            sm: "fixed"
          },
          zIndex: "1111",
          backgroundColor: "#f6f7ff",
          top: {
            xs: "70px",
            sm: "82px",
            md: "64px",
          },
          paddingTop: "12px",
          // width: "100%",
          // paddingRight: "560px",
          // paddingTop: "50px",
          // marginTop: "-50px",
        }}
      >
        <div
          style={{
            marginTop: "0px",
            marginBottom: "10px",
            fontSize: "1rem",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "0.5rem",
          }}
        >
          <div
            className="col-6"
            style={{
              marginTop: "0px",
              // flex: "1 0 50%",
              // maxWidth: "75%",
              justifyContent: "flex-start",
              textAlign: "end",
              display: "flex",
              flexWrap: "wrap",
              gap: "0.5rem",
            }}
          >
            {props.mode === "PREVIEW" &&
            props.agentState !== "CLOSURE" &&
            props.agentState !== "CONF" &&
            props.agentState !== "INCALL" &&
            props.agentState !== "PREVIEW_FAIL" &&
            props.agentState !== "BREAK" ? (
              <DialpadIcon />
            ) : (
              ""
            )}
            {props.facilityConf.conferencing !== "1" &&
              confShow &&
              props.agentState !== "CONF" && (
                <div>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    style={{
                      textTransform: "capitalize",
                      border: "2px solid",
                      marginInlineStart: "0",
                    }}
                    className={classes.ConferenceButton}
                    onClick={handleConfFlag}
                  >
                    <GroupIcon />
                    &nbsp;
                    {confFlag ? "Back To Main" : "Conference"}
                  </Button>
                </div>
              )}
              {/* {props.campConf.call_park === "1" &&
               (
                <div>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    style={{
                      textTransform: "capitalize",
                      border: "2px solid",
                      marginLeft: "10px",
                    }}
                    className={classes.ConferenceButton}
                    onClick={handleCallPark}
                  >
                    <CallIcon />
                    &nbsp;
                    Call Park
                  </Button>
                </div>
              )} */}
          
            {props.facilityConf.conferencing !== "1" &&
              props.callBack !== "1" &&
              props.agentState === "CONF" && (
                <div>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    style={{
                      textTransform: "capitalize",
                      border: "2px solid",
                      marginInlineStart: "0",
                    }}
                    className={classes.ConferenceButton}
                    onClick={leaveConf}
                  >
                    {props.loading && props.actionType === "leaveConf" ? (
                      <CircularProgress
                        size={18}
                        style={{
                          verticalAlign: "middle",
                        }}
                      />
                    ) : (
                      <CallEndIcon />
                    )}
                    &nbsp;Back To Queue
                  </Button>
                </div>
              )}
            {props.facilityConf.conferencing !== "1" &&
              props.agentState === "INCALL" &&
              confFlag &&
              confShow && (
                <div>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    style={{
                      textTransform: "capitalize",
                      border: "2px solid",
                    }}
                    className={classes.ConferenceButton}
                    onClick={joinConf}
                  >
                    {props.loading && props.actionType === "joinConf" ? (
                      <CircularProgress
                        size={18}
                        style={{
                          verticalAlign: "middle",
                        }}
                      />
                    ) : (
                      <CallEndIcon />
                    )}
                    &nbsp;Transfer Both
                  </Button>
                </div>
              )}
            {props.facilityConf.conferencing !== "1" &&
              props.agentState === "INCALL" &&
              confFlag &&
              confShow && (
                <div>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    style={{
                      textTransform: "capitalize",
                      border: "2px solid",
                    }}
                    className={classes.ConferenceButton}
                    onClick={joinCustomer}
                  >
                    {props.loading && props.actionType === "joinCustomer" ? (
                      <CircularProgress
                        size={18}
                        style={{
                          verticalAlign: "middle",
                        }}
                      />
                    ) : (
                      <CallEndIcon />
                    )}
                    &nbsp;Transfer Customer
                  </Button>
                </div>
              )}
            {props.facilityConf.conferencing !== "1" &&
              confFlag &&
              confShow &&
              (props.agentState === "FREE" || props.agentState === "BREAK") &&
              props.confDetails &&
              props.confDetails.room_details &&
              props.confDetails.room_details.length !== 0 && (
                <div>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    style={{
                      textTransform: "capitalize",
                      border: "2px solid",
                    }}
                    className={classes.ConferenceButton}
                    onClick={joinAgent}
                  >
                    {props.loading && props.actionType === "joinAgent" ? (
                      <CircularProgress
                        size={18}
                        style={{
                          verticalAlign: "middle",
                        }}
                      />
                    ) : (
                      <CallEndIcon />
                    )}
                    &nbsp;Transfer Agent
                  </Button>
                </div>
              )}
            {(props.facilityConf.transfer === "0" ||
              props.facilityConf.disable_transferable_campaigns === "0" ||
              props.campConf.transfer_to === "1") &&
              props.agentState === "INCALL" &&
              !confFlag && <TransferCallButton />}

              {props.campConf.call_park === "1" && props.agentState !== "CONF" &&
               (
                <div>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    style={{
                      textTransform: "capitalize",
                      border: "2px solid",
                      marginInlineStart: "0",
                    }}
                    className={classes.ConferenceButton}
                    onClick={showParkCall}
                  >
                    <CallIcon />
                    &nbsp;
                  Park Conference
                  </Button>
                </div>
              )}
          </div>

          <div
            className="col-6"
            style={{
              marginTop: "0px",
              // flex: "1 0 50%",
              // maxWidth: "25%",
              justifyContent: "flex-end",
              textAlign: "end",
              display: "flex",
             flexWrap: "wrap",
              gap: "0.5rem",
            }}
          >
            {props.facilityConf.conferencing !== "1" &&
              props.agentState !== "CONF" &&
              props.agentState !== "BREAK" &&
              confFlag &&
              confShow && (
                <div>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    style={{ margin: "0px" }}
                  >
                    <NativeSelect
                      className={classes.selectEmpty}
                      value={confRoom}
                      name="age"
                      onChange={(e) => setConfRoom(e.target.value)}
                      inputProps={{ "aria-label": "age" }}
                      disabled={multiConf ? false : true}
                      style={{
                        paddingTop: "16px",
                        paddingBottom: "16px",
                      }}
                    >
                      <option value={1}>&nbsp;Conf Room 1</option>
                      <option value={2}>&nbsp;Conf Room 2</option>
                      <option value={3}>&nbsp;Conf Room 3</option>
                    </NativeSelect>
                  </FormControl>
                </div>
              )}  
            {props.agentState === "INCALL" && !confFlag && <HoldButton />}
            {props.agentState === "INCALL" && !confFlag && <DtmfButton />}
          </div>
        </div>
      </Box>
      </div>
      {(props.agentState === "READY" || props.agentState === "BREAK") &&
      props.breakType !== "JoinedConference" && props.breakType !== "ParkTransfered" ? (
        <Card style={{ height: "705px", textAlign: "center" }}>
          <Typography style={{ paddingInlineStart: "0px" }}>
            <img
              src={Progressive}
              alt="Progressive"
              style={{
                maxWidth: "100%",
                height: "auto",
                margin: "0px auto",
                padding: "110px 30px 15px",
                textAlign: "center",
                display: "block",
              }}
            />
            <span style={{ textAlign: "center" }}>Welcome to C-Zentrix</span>
          </Typography>
        </Card>
      ) : (
        ""
      )}


      {(props.facilityConf.conferencing !== "1" ||
        props.breakType === "JoinedConference") &&
      confFlag &&
      confShow ? (
      <Box sx={{ marginTop: {xs:"20px", sm:"70px"} }}>
          <Conference />
        </Box>
      ) : null}

      

{/* Break Reason */}

{(props.agentState === "BREAK" &&
        props.breakType === "JoinedConference") ? (
        <div style={{ marginTop: "70px" }}>
          <Break />
        </div>
      ) : null}

      {/* {
  ( props.confDetails.room_details &&
    props.confDetails.room_details.length > 0 ||
    (props.confDetails.vdn_details?.length > 0 ||
      props.breakType === "JoinedConference") &&
    confFlag &&
    confShow) ? (
    <div style={{ marginTop: "70px" }}>
      <Conference />
    </div>
  ) : null
} */}


      {props.agentState === "INCALL" ||
      props.agentState === "CLOSURE" ||
      props.agentState === "PREVIEW_FAIL" ? (
     <Box
        sx={{ 
          marginTop: {
          xs: "20px",
          sm: "50px",
          },
        }}>
          <PhoneTypes />
        </Box>
      ) : null}

{
  
  (props.agentState === "INCALL" ||
    props.agentState === "CLOSURE" ||
    props.agentState === "PREVIEW_FAIL") &&
  activeLeadId !== "0" ? (
    <>
      {(() => {
        return (
          <>
            {validPanels.map((item, index) => {
  const panelId = `panel${index}`;
  return (
    <Accordion
      key={`${index}-${props.custPhone}`}
      square
      expanded={expanded.includes(panelId)}
      onChange={handleChange(panelId)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${panelId}d-content`}
        id={`${panelId}d-header`}
        className="summarypanel-details"
      >
        <Typography className={classes.EditIconDetails}>
          {item.groupLabel}
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        {!editMode[panelId] ? (
          <ShowCustomerDetails
            handleUpdate={handleUpdate}
            handleCrmChange={handleCrmChange}
            group={item.group}
            crmValues={crmValues}
            facilityConf = {props.facilityConf}
          />
        ) : (
          <EditCustomerDetails
            handleUpdate={handleUpdate}
            agentState={props.agentState}
            handleCrmChange={handleCrmChange}
            status={props.status}
            onDisconnectIconClick={props.onDisconnectIconClick}
            editMode={editMode[panelId]}
            group={item.group}
            crmValues={crmValues}
            onRequestAgentDial={handleAgentDial}
          />
        )}

        {!editMode[panelId] && (
          <div className={classes.EditIcon}>
            <EditIcon
              id="btnEditIcon"
              onClick={() => setPanelWiseEditMode(panelId, true)}
              style={{
                color: "#4A4A4A",
                justifyContent: "flex-end",
                textAlign: "end",
                cursor: "pointer",
              }}
            />
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  );
})}
            {validPanels.length > 0 && (
              <Grid
                className={classes.Buttons}
                container
                spacing={1}
                style={{ justifyContent: "flex-end" }}
              >
                <Button
                  id="btnUpdate"
                  className={classes.UpdateButton}
                  variant="contained"
                  color="primary"
                  onClick={handleUpdate}
                  style={{ marginTop: "16px", marginBottom: "16px" }}
                  disabled={!Object.values(editMode).some((mode) => mode)}
                >
                  {props.loading ? (
                    <CircularProgress size={18} style={{ verticalAlign: "middle" }} />
                  ) : (
                    "Update"
                  )}
                </Button>
              </Grid>
            )}
          </>
        );
      })()}
    </>
  ) :null
}
        
      {props.agentState !== "CONF" && activeLeadId && !crmFields.length ? (
        <Typography className={classes.EditIconDetails}></Typography>
      ) : null}
    

    {
        showCallPark && (
           <div style={{ marginTop: "70px" }}>
          <CallParking />
        </div>
        )
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    error: state.agentConf.error,
    loading: state.agentConf.loading,
    actionType: state.agentConf.actionType,
    status: state.callDisp.status,
    crmError: state.customerDetails.error,
    crmLoading: state.customerDetails.loading,
    crmFields: state.customerDetails.crmFields,
    crmValues: state.customerDetails.crmValues,
    activeLeadId: state.customerDetails.leadId,
    custPhone: state.agentData.custPhone,
    breakType: state.agentData.breakType,
    failedReason: state.agentData.failedReason,
    leadId: state.agentData.leadId,
    campaignId: state.agentData.campaignId,
    agentState: state.agentData.agentState,
    newFeatures: state.agentConfig.newFeatures,
    facilityConf: state.agentConfig.facilityConf,
    confDetails: state.agentConf.confDetails,
    campConf: state.agentConfig.campConf,
    agentId: state.agentData.agentId,
    callBack: state.agentData.callBack,
    sessionId: state.agentData.sessionId,
    mode: state.agentData.dialerType,
    callConfDetails: state.callParking.confDetails,
    accordinFlag : "true",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAgentDisconnect: (agentId) => dispatch(actions.agentDisconnect(agentId)),
    onGetCustomerDetails: (agentId, campaignId, leadId) =>
      dispatch(actions.getCustomerDetails(agentId, campaignId, leadId)),
    onLeaveConf: (agentId) => dispatch(actions.leaveConf(agentId)),
    onJoinConf: (agentId, cond, confRoom, exten) =>
      dispatch(actions.joinConf(agentId, cond, confRoom, exten)),
    onGetConfDetails: (agentId) => dispatch(actions.getConfDetails(agentId)),
    onCustomerDetails: (agentId, campaignId, leadId, setValues) =>
      dispatch(actions.customerDetails(agentId, campaignId, leadId, setValues)),
    onCustomerDetails: (agentId, campaignId, leadId, setValues) =>
      dispatch(actions.customerDetails(agentId, campaignId, leadId, setValues)),
    onResetCustomerDetails: () => dispatch(actions.resetCustomerDetails()),
    onRestDisconnect :() => dispatch(actions.agentDisconnectReset()),
    onAgentDial: (agentId, phone, leadId, listId, callerId, redial, phoneType) =>
          dispatch(actions.agentDial(agentId, phone, leadId, listId, callerId, redial, phoneType)),
    //onModeChange: (agentId, mode, agentState) => dispatch(actions.modeChange(agentId, mode, agentState)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomizedExpansionPanels);
